export default __webpack_public_path__ + "static/media/CABORENTED.3cd16b1e.png";